import { StoryblokServerComponent } from '@storyblok/react/rsc';
import ToggleClient from '@/components/ToggleClient';

/**
 * Server wrapper for the toggle control. In the "custom" variant each option is
 * built from nested bloks (server components), so they're rendered here and
 * handed to the client component, which owns the selection state — the same
 * split as ToggleTarget / ToggleTargetClient.
 */
const renderOption = (bloks) => (bloks || []).map((nestedBlok) => (
  <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
));

const Toggle = ({ blok }) => (
  <ToggleClient
    blok={blok}
    primaryContent={renderOption(blok.primary_content)}
    secondaryContent={renderOption(blok.secondary_content)}
  />
);

export default Toggle;
